import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Translate from "../translate/Translate";

import MainTopNav from "./MainTopNav";
import MainFooter from "./MainFooter";

import hex from "../static/history-hex.png";

class MainHistory extends Component {

    render() {
        return (
            <div className="searchJob-container">
                <div className="static-banner-history">
                    <MainTopNav />
                    <div className="jobSearch-title"><Translate id="main.history.title"/></div>
                </div>
                <div className="history-main">
                    <div className="history-title"><Translate id="main.history.subtitle1"/></div>
                    <div className="history-description"><Translate id="main.history.section1"/></div>

                    <div className="history-title"><Translate id="main.history.subtitle2"/></div>
                    <div ><img src={hex} className="history-image"></img></div>
                    <div className="history-description"><Translate id="main.history.section2"/></div>
                
                    <div className="history-title"><Translate id="main.history.subtitle3"/></div>
                    <div className="history-description"><Translate id="main.history.section3.1"/></div>
                    <div className="history-description2"><Translate id="main.history.section3.2"/></div>


                </div>
                <MainFooter/>
            </div>


        )
    }
}

const mapStateToProps = state => ({
    language: state.mainpage.language
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {

        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MainHistory);
